import React, { ComponentType, HTMLProps } from 'react';
import { useFormControlGroup } from './FormControlGroup';

interface ControlProps extends Omit<HTMLProps<HTMLInputElement>, 'ref'> {
    error?: boolean;
    indeterminate?: boolean;
}

export const makeCheckedControl =
    (Component: ComponentType<ControlProps>) => (props: ControlProps) => {
        const { value: groupValue, ...formControlGroup } = useFormControlGroup();

        return (
            <Component
                {...formControlGroup}
                onClick={(event) => {
                    props.onClick?.(event);
                    event.stopPropagation();
                }}
                checked={
                    Array.isArray(groupValue)
                        ? groupValue.includes(props.value)
                        : groupValue === props.value
                }
                {...props}
            />
        );
    };
